import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PresenceService } from '../services';
import { merge, timer } from 'rxjs';
import { filter, map, scan, take, withLatestFrom } from 'rxjs/operators';
import { HubConnectionState } from '@microsoft/signalr';

@Component({
  selector: 'app-presence',
  template: `
    <li role="button" class="nav-item" (click)="popStateSelection()">
      <ng-container *ngIf="viewModel$ | async as vm">
        <span class="nav-link text-dark">
          <span>{{ vm.name }}</span>
          <span class="d-inline-block text-right ml-2" style="min-width: 3em;">
            {{ vm.duration }}
          </span>
          <i class="fas fa-circle mx-2" [ngStyle]="{ color: vm.color }"></i>
        </span>
      </ng-container>
    </li>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PresenceComponent {
  tick$ = timer(1000, 1000);

  viewModel$ = merge(
    this.tick$.pipe(
      withLatestFrom(
        this.presenceSvc.presence$,
        this.presenceSvc.states$,
        this.presenceSvc.hubState$
      ),
      filter(([, presence]) => !!presence),
      map(([, presence, states, hubState]) => {
        const name = states.find(
          (ps) => ps.id === presence.stateId
        )?.description;
        const now = new Date();
        const totalSeconds = Math.floor(
          (now.getTime() - presence.beginLocal.getTime()) / 1000
        );
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds - hours * 3600) / 60);
        const seconds = totalSeconds % 60;
        const duration =
          (hours > 0 ? `${hours}:` + `0${minutes}`.slice(-2) : `${minutes}`) +
          ':' +
          `0${seconds}`.slice(-2);

        let color = 'green';
        switch (hubState!) {
          case HubConnectionState.Reconnecting:
            color = 'orange';

            break;
          case HubConnectionState.Disconnected:
            color = 'red';

            break;
        }
        return {
          color,
          name,
          duration,
        };
      })
    )
  ).pipe(scan((acc, value) => ({ ...acc, ...value }), {} as ViewModel));

  constructor(private presenceSvc: PresenceService) {}

  popStateSelection() {
    this.presenceSvc.popStateSelectionModal();
  }
}

interface ViewModel {
  color: string;
  duration: string;
  name: string | undefined;
}
